import type { FC, ReactNode } from "react";

import type { ContentGateRestriction, RestrictionType } from "@jti/fe-common";

import { ContentGatePopup } from "../ContentGatePopup";
import type { Language } from "../LanguageSelector";

import { useContentGateRestrictions } from "./hooks/useContentGateRestrictions";

export type { ContentGateRestriction, RestrictionType };

export interface ContentGateProps {
  externalContent?: ReactNode;
  languages: Language[];
  logoSrc: string;
  title: string;
  whyContentRestricted: { label: string; link: string };
  restrictions: ContentGateRestriction[];
}

export const ContentGate: FC<ContentGateProps> = ({
  externalContent,
  languages,
  logoSrc,
  title,
  whyContentRestricted,
  restrictions,
}) => {
  const { activeRestrictions, isDialogOpen } = useContentGateRestrictions(restrictions);

  return (
    <ContentGatePopup
      externalContent={externalContent}
      title={title}
      logoSrc={logoSrc}
      languages={languages}
      whyContentRestricted={whyContentRestricted}
      restrictions={activeRestrictions}
      isOpen={isDialogOpen}
    />
  );
};
